import { useState, useEffect } from 'react';
import { useDebounce } from './useDebounce';
import { producaov2 } from '../services/apis';

export default function useUserSearch({search = ''}) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      setLoading(true);

      try {
        const response = await producaov2.get(`/alunos`, {
          params: {
            search,
            limit: 15,
            additional_fields: 'cpf, celular, endereco, cep, numero, bairro, cidade, estado, complemento'
          }
        });

        if(isMounted) {
          setData(response.data || []);
        }
      } catch(error) {
        setError(error);
      } finally {
        if(isMounted) {
          setLoading(false);
        }
      }
    }

    getData();

    return () => {
      isMounted = false;
    }
  }, [search]);


  return {
    data,
    error,
    loading,
  }
}